{
  "Login": "Login",
  "Local Login": "Local Login",
  "email": "email",
  "password": "password"
}
